export const AlertVueComponent = {
  props: {
    alertMessage: String,
    alertType: String,
  },
  data() {
    return {
      alertTypeDict: {
        info: "alert-primary",
        error: "alert-danger",
        warn: "alert-warn",
        success: "alert-success",
      },
    };
  },
  template: `
	<div class="alert alert-outline-coloured alert-dismissible mb-0" role="alert" :class="[alertType ? alertTypeDict[alertType] : alertTypeDict['info']]">
		<div class="alert-icon">
      <slot name="icon">
			  <i class="far fa-fw fa-bell"></i>
      </slot>
		</div>
		<div class="alert-message"> 
      <slot name="message">
        {{alertMessage}}
      </slot>
    </div>
	</div>
	`,
};
